/**
 * Created by Ning Jiang on 1/14/2020.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IMultiSpritesConfig, MultiSprites} from "@nolimitcity/slot-game/bin/core/displayobject/MultiSprites";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetWayWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";

export class DeadwoodWaysWonGFXText extends BaseView {

    private readonly _waysWonNumberStyle:any = {
        fontName : "NumbersWaysWon",
        fontSize : 30,
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };
    private readonly _wayWonTexts:string[] = ["wayWon", "waysWon"];
    private readonly _fadeInDuration:number = 0.5;
    private _fadeOutDuration:number;
    private readonly _endScale:number = 0.6;
    private readonly _endPositionY:number = 460;
    private readonly _bigWinEndPositionY:number = 550;
    private readonly _maxWidth:number = GameConfig.instance.REEL_AREA_WIDTH * 0.8;

    private _waysWonContainer:PIXI.Container;
    private _waysWonNumber:PIXI.BitmapText;
    private _waysWonText:MultiSprites;
    private _currentTimeline:TimelineLite;

    private _winWaysTotal:number;

    constructor() {
        super();
    }

    protected initAnimations():void {
        const layer:ScalableLayer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.WIN_COUNT_UP.name);
        this._waysWonContainer = new PIXI.Container();
        layer.addChild(this._waysWonContainer);

        const waysWonConfig:IMultiSpritesConfig = {};
        this._wayWonTexts.forEach((text:string) => {
            waysWonConfig[text] = {
                textures : GameResources.getTextures(`${text}Text`),
                anchor : [0, 0.5]
            }
        });
        this._waysWonText = new MultiSprites(waysWonConfig);
        this._waysWonContainer.addChild(this._waysWonText);

        this._waysWonNumber = new PIXI.BitmapText("", this._waysWonNumberStyle);
        (<PIXI.Point>this._waysWonNumber.anchor).set(0, 0.55);
        this._waysWonContainer.addChild(this._waysWonNumber);

        this._waysWonContainer.visible = false;
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:ParsedGameData):void {
        this._winWaysTotal = 0;
        if(data.betWins) {
            data.betWins.forEach((betWayWin:IBetWinData) => {
                this._winWaysTotal += (<IBetWayWinData>betWayWin).numberOfCombinations;
            });
        }
    }

    public showWinWaysWon(winWaysWon:number, animate:boolean, isBigWin:boolean):void {
        winWaysWon = winWaysWon != undefined ? winWaysWon : this._winWaysTotal;
        animate = animate != undefined ? animate : true;
        const wayWonText:string = winWaysWon === 1 ? this._wayWonTexts[0] : this._wayWonTexts[1];

        this.completeTimeline();
        const timeline:TimelineLite = new TimelineLite({paused : true});
        timeline.add([
            TweenLite.fromTo(this._waysWonNumber, animate ? this._fadeInDuration : 0, {alpha : 0}, {alpha : 1}),
            this._waysWonText.playSprite(wayWonText,
                {
                    duration : animate ? this._fadeInDuration : 0,
                    vars : [{fromVars : {alpha : 0}, toVars : {alpha : 1}}]
                }),
            () => {
                this._waysWonNumber.text = "" + winWaysWon;
                this._waysWonContainer.scale.set(this._endScale);
                this._waysWonContainer.position.set(GameConfig.instance.GAME_WIDTH / 2, isBigWin ? this._bigWinEndPositionY : this._endPositionY);
                this.updatePositions(wayWonText);
                this._waysWonContainer.visible = true;
            }
        ]);

        this._currentTimeline = timeline;
        this._currentTimeline.play();
    }

    private completeTimeline():void {
        if(this._currentTimeline && this._currentTimeline.isActive()) {
            this._currentTimeline.progress(1);
        }
    }

    private updatePositions(spriteName:string):void {
        this._waysWonNumber.updateTransform();
        const totalWidth:number = this._waysWonNumber.width + this._waysWonText.sprites[spriteName].width;
        this._waysWonNumber.x = -totalWidth / 2;
        this._waysWonText.x = this._waysWonNumber.x + this._waysWonNumber.width;
    }

    public abort(isAborted:boolean, isBigWin:boolean):void {
        this.completeTimeline();
        this._fadeOutDuration = (isBigWin && !isAborted) ? 0 : 0.8;
        const wayWonText:string = this._winWaysTotal === 1 ? this._wayWonTexts[0] : this._wayWonTexts[1];
        if(isAborted) {
            this.showWinWaysWon(this._winWaysTotal, false, isBigWin);
        }
        //ending
        const finishTimeline:TimelineLite = new TimelineLite();
        finishTimeline.add(() => {
            TweenLite.to(this._waysWonNumber, this._fadeOutDuration, {alpha : 0});
            this._waysWonText.playSprite(wayWonText,
                {
                    duration : this._fadeOutDuration,
                    vars : [{toVars : {alpha : 0}}]
                })
        }, `+=${(isBigWin && !isAborted) ? 0 : 0.8}`);

        finishTimeline.add(() => {this._waysWonContainer.visible = false;});
    }
}